import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import { clearAuthToken } from './auth';
import { logout, selectIsSigningOut, setIsSigningOut } from 'common/store/slices/auth.slice';
import { useLocation } from 'react-router-dom';
import { PROFILE_CAPTURE_ROUTES } from 'routes/routes.const';
import { useCompareUrlWithProjectId } from './route';
import { clearConfig } from 'common/store/slices/page-config.slice';
import { toggleSidebar } from 'common/store/slices/layout.slice';

interface UseSignOut {
  signout: () => void;
  isSigningOut: boolean;
}

function useSignOut(): UseSignOut {
  const { logout: auth0Logout, isLoading: auth0Loading } = useAuth0();
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const { compareUrl } = useCompareUrlWithProjectId();
  const isProfileCapture = compareUrl(PROFILE_CAPTURE_ROUTES.root, { includes: true });
  const isSigningOut = useSelector(selectIsSigningOut);

  const signout = async () => {
    if (isSigningOut || auth0Loading) {
      return; // Prevent multiple logout attempts
    }

    dispatch(setIsSigningOut(true));

    if (isProfileCapture) {
      localStorage.setItem('previousKwelloPath', pathname);
      localStorage.setItem('previousSearchValues', search);
    } else {
      localStorage.removeItem('previousSearchValues');
      localStorage.removeItem('previousKwelloPath');
    }

    try {
      clearAuthToken();
      dispatch(logout());
      dispatch(clearConfig());
      dispatch(toggleSidebar(false));

      await auth0Logout({
        logoutParams: { returnTo: globalThis.location.origin },
      });
    } catch (err) {
      console.error('Error during signout process:', err);
    } finally {
      dispatch(setIsSigningOut(false));
    }
  };

  return { signout, isSigningOut };
}

export default useSignOut;
